import { createElement, useCallback } from 'react';
import './index.scss';
const ColorfulIcon = function ColorfulIcon({ icon, onClick, ..._otherProps }) {
    const handleClick = useCallback((e) => {
        if (onClick) {
            return onClick(e);
        }
    }, [onClick]);
    return (createElement("label", { className: 'au-icon-model', ..._otherProps, onClick: handleClick },
        createElement("i", { className: icon || "icon-light-alarm-clock" })));
};
ColorfulIcon.displayName = 'ColorfulIcon';
export default ColorfulIcon;
